import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["output"]

  connect() {
    console.log("Hello World!")
    // Don't modify the element on connect since we're using a target for output
  }

  greet() {
    console.log("Greet action called!")
    this.outputTarget.value = "Hello from the greet action!"
  }
}
